import { ClassNameMap } from '@mui/material';
import { makeStyles  } from 'tss-react/mui';

const MAIN_CONTAINER_WIDTH = '996px';
const CONTENT_CONTAINER_WIDTH = '588px';
const SCHEDULER_CONTAINER_WIDTH = '400px';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useSelectedProviderStyles = makeStyles({ name: 'SelectedProvider' })(theme => ({
  fontWeight450: {
    fontWeight: 450,
  },
  fontWeight600: {
    fontWeight: 600,
  },
  fontSize18: {
    fontSize: '18px'
  },
  fontSize16: {
    fontSize: '16px'
  },
  prewrap: {
    whiteSpace: 'pre-wrap'
  },
  inlineBlock: {
    display: 'inline-block'
  },
  selectedSpecialty: {
    fontWeight: 600,
    lineHeight: 1.2,
  },
  collapseItemButton: {
    width: '100%',
    cursor: 'pointer',
  },
  paymentLabel: {
    marginBottom: 0,
    display: 'flex',
    height: '21px',
    alignItems: 'center'
  },
  modalTitle: {
    paddingBottom: theme.spacing(1)
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0
  },
  modalActions: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    gap: theme.spacing(1),
  },
  alertTitle: {
    marginBottom: 0,
  },
  alert: {
    padding: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 700,
    lineHeight: '266%',
    fontSize: '12px',
    textTransform: 'uppercase',
    color: theme.palette.secondary.main,
    letterSpacing: '1px',
  },
  expertiseChip: {
    fontSize: '16px',
  },
  listItemText: {
    marginTop: 0,
    marginBottom: 0,
  },
  scheduleSessionFooter: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    background: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  }
}));

type UseSelectedProviderStickyStylesProps = {
  isScrollableView?: boolean;
  hideScheduler?: boolean;
  classes?: Partial<ClassNameMap<'root' | 'mainContainer'>>;
  appBarOffset?: number;
  mainContainerWidth?: string;
  forceMobile?: boolean;
};

const APPBAR_OFFSET = 64;

const getAppBarOffset = (appBarOffset: number | undefined) => appBarOffset ?? APPBAR_OFFSET;

export const useSelectedProviderLayoutStyles = makeStyles<Partial<UseSelectedProviderStickyStylesProps>>({ name: 'SelectedProviderLayout' })((theme, { forceMobile, mainContainerWidth, hideScheduler, isScrollableView, appBarOffset }) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.grey[50],
    position: 'relative',
  },
  mainContainer: ({
    maxWidth: mainContainerWidth ?? MAIN_CONTAINER_WIDTH,
    marginRight: 'auto',
    marginLeft: 'auto',

    ...(!forceMobile && ({
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 2),
      }
    }))
  }),
  contentContainer: ({
    maxWidth: CONTENT_CONTAINER_WIDTH,

    ...(!forceMobile && ({
      [theme.breakpoints.up('md')]: {
        marginRight: hideScheduler ? undefined : SCHEDULER_CONTAINER_WIDTH,
      }
    }))
  }),
  headerContainer: ({
    padding: theme.spacing(2, 2, hideScheduler ? 2 : 0),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    borderBottom: hideScheduler ? 'none' : `1px solid ${theme.palette.divider}`,

    ...(!forceMobile && ({
      [theme.breakpoints.up('sm')]: {
        borderBottom: 'none',
        gap: 0,
        padding: theme.spacing(5, 2, 4, 2)
      }
    }))
  }),
  fullBgWhite: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  headerBottomDivider: {
    margin: theme.spacing(0, 2),
  },
  schedulerContainer: {
    display: hideScheduler ? 'none' : 'block',
    position: 'absolute',
    top: 0,
    right: `max(calc(calc(100% - ${MAIN_CONTAINER_WIDTH}) / 2), 8px)`,
    width: SCHEDULER_CONTAINER_WIDTH,
    height: '100%',
  },
  stickyScheduler: {
    position: 'sticky',
    padding: theme.spacing(0, 1),
    zIndex: theme.zIndex.appBar + 2,
    top: `${(isScrollableView ? 0 : getAppBarOffset(appBarOffset)) + 32}px`,
    paddingBottom: theme.spacing(5),
  },
  stickyTabs: {
    position: 'sticky',
    top: `${isScrollableView ? 0 : getAppBarOffset(appBarOffset)}px`,
    zIndex: theme.zIndex.appBar + 1,
    background: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));
